import type { LineReducerOutput, Response } from "../schema";

export const lineReducer = (
  prev: LineReducerOutput,
  line: string,
  index: number,
  lines: string[]
): LineReducerOutput => {
  let { previousLine } = prev;

  // If we only have one line, or this is the final line, this is part of a larger chunk.
  // So we add it to the last line and move on.
  if (lines.length === 1 || index === lines.length - 1) {
    return { ...prev, previousLine: prev.previousLine + line };
  }

  // Concatenate previous line if first chunk (and it's implied there
  // are further chunks).
  if (index === 0) {
    line = previousLine + line;
    previousLine = "";
  }

  const data: Response = JSON.parse(line);

  if ("error" in data) {
    return {
      previousLine,
      successes: prev.successes,
      errors: [...prev.errors, data],
    };
  }

  return {
    previousLine,
    successes: [...prev.successes, data],
    errors: prev.errors,
  };
};
